import { ComponentType } from 'react'
import { useStoreActions, useStoreState } from 'hooks/useStore'
import { Col, Container, Row } from 'reactstrap'

export const TextHeroMobile: ComponentType<{ title?: string, subtitle?: string }> = ({ title, subtitle }) => {
    const invader = useStoreState(store => store.ui.invader)
    const setInvader = useStoreActions(actions => actions.ui.setInvader)

    return (
        <div></div>
    )
}
